<template>
	<div>

		<div class="mar-t-1rem ">
			<div class="nav">
				<!-- <img src="/static/images/tishi2.png"> -->
        <div class="title">温馨提示</div>
				<div class="notice">
					<ul>
						<li>
							<div>1.</div>
							<div>请仔细核对充值号码，号码错误将无法退款</div>
						</li>
						<li>
							<div>2.</div>
							<div>支付成功后预计1分钟到账，高峰期或有延迟</div>
						</li>
						<li>
							<div>3.</div>
							<div>若1小时未到账,请联系客服</div>
						</li>
					</ul>
				</div>
			</div>
		</div>


		<div class="twoCodeArea">
			<img src="/static/images/erweima.jpg" alt="">
		</div>
		<div class="clear"></div>
	</div>

</template>
<script>

export default{
	name:"notice",

}
</script>
<style scoped>
.clear{
	overflow: hidden;
  margin-bottom: 30px;
}
ul{
	padding-left: 0;
	/* margin-left: 1rem;
	margin-right: 1rem; */
  margin-left: 20px;
  margin-right: 20px;
}
.mar-t-1rem{
	margin-top: 1rem;
	/* margin-bottom: 2rem; */
  margin-bottom: 1rem;
}
.nav{
	position: relative;
	width: calc(100% - 6px );
	margin: 0 auto ;
	/*border: 3px solid #666;*/
  box-sizing: border-box;
  padding-top: 10px;
}
.nav .title{
  font-size: 16px;
  color:#848484;
}
.nav img{
	position: absolute;
	top: -3.8rem;
	left: 0;
	width: 15rem;
}
.nav .notice{
	/* padding-top: 10px; */
  color: #848484;
}
.nav .notice ul li{
	display: block;
	overflow: hidden;
	line-height: 20px;
	font-size: 14px;
	text-align: left;
}
.nav .notice ul li div{
	float:left
}
.nav .notice ul li div:first-child{
	width:5%;

}
.nav .notice ul li div:nth-child(2){
	width: 95%;
}

.twoCodeArea img{
	width:40%;
}

</style>



// WEBPACK FOOTER //
// src/components/notice.vue